import BlockIcon from "@mui/icons-material/Block";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { RBACRole } from "../../../api/rbac/types";
import { ConfigContext } from "../../../context/ConfigContext";
import { DealerAccountContext } from "../../../context/DealerAccountContext";
import { UserContext } from "../../../context/UserContext/UserContext";
import { ALL_ACCOUNTS } from "../../../utils/constants";
import { getHomeUrl } from "../../../utils/legacyHome";

interface INoItemsFoundInfo {
  itemListName: string;
  dataTestId: string;
}

const NoItemsFoundInfo = ({ itemListName, dataTestId }: INoItemsFoundInfo) => {
  const theme = useTheme();
  const { t } = useTranslation("common");
  const { JDPO_JAVA_URL, JDPOINT_URL, ENABLE_REMOVE_DASHBOARD_TAB } =
    useContext(ConfigContext);
  const user = useContext(UserContext);
  const { dealerAccount, selectedAccounts } = useContext(DealerAccountContext);

  const dealerAccountId =
    user?.is(RBACRole.CORPORATE_PARTS_MANAGER) && selectedAccounts.length > 1
      ? ALL_ACCOUNTS
      : (dealerAccount?.id as string);

  const homeUrl = getHomeUrl(
    JDPO_JAVA_URL,
    JDPOINT_URL,
    dealerAccountId ?? "",
    ENABLE_REMOVE_DASHBOARD_TAB
  );

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        margin: "190px",
      }}
      data-testid={dataTestId}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <BlockIcon
          data-testid="blockIcon"
          sx={{ color: theme.tokens.FuelColorBorderDark }}
          fontSize="large"
        />
        <Typography
          sx={{
            textAlign: "center",
            paddingTop: theme.tokens.FuelSpacing4,
            paddingBottom: theme.tokens.FuelSpacing6,
            fontWeight: theme.tokens.FuelFontWeightSemibold,
          }}
          component="p"
        >
          {t("table.noItemsFound", { itemListName })}
        </Typography>
        <Link to={homeUrl} data-testid="return-home-button">
          <Button
            sx={{ width: "fit-content", minWidth: "140px" }}
            variant="primary"
          >
            {t("table.returnHome")}
          </Button>
        </Link>
      </Box>
    </Box>
  );
};

export default NoItemsFoundInfo;
